import { Icons } from '@shared/components/content/icons';
import { cn } from '@shared/lib/utils';

interface TransportIconProps {
  transportModeId: string;
  transportModeOptions: Array<{ value: string; label: string }>;
  className?: string;
}

export const TransportIcon = ({
  transportModeId,
  transportModeOptions,
  className,
}: TransportIconProps) => {
  // Find the transport mode name by ID
  const transportMode = transportModeOptions.find(
    (option) => option.value === transportModeId
  );
  const transportModeName = transportMode?.label || '';

  const combinedClassName = cn('size-6 shrink-0 text-primary-400', className);

  // Map transport modes to icons based on the requirements
  const transportModeIconMap: Record<string, React.ReactNode> = {
    // HGV variants - truck
    'HGV, rigid': <Icons.truck className={combinedClassName} />,
    'HGV, articulated': <Icons.truck className={combinedClassName} />,

    // Van variants
    'Van, diesel': <Icons.truck className={combinedClassName} />,
    'Van, petrol': <Icons.truck className={combinedClassName} />,
    'Van, hybrid': <Icons.truckElectric className={combinedClassName} />,
    'Van, electric': <Icons.truckElectric className={combinedClassName} />,

    // Other transport modes
    'Freight train': <Icons.train className={combinedClassName} />,
    'Cargo ship': <Icons.ship className={combinedClassName} />,
    Plane: <Icons.plane className={combinedClassName} />,
    Car: <Icons.car className={combinedClassName} />,
    Motorcycle: <Icons.bike className={combinedClassName} />,
    Bicycle: <Icons.bike className={combinedClassName} />,
  };

  return (
    transportModeIconMap[transportModeName] || (
      <Icons.truck className={combinedClassName} />
    )
  );
};
